import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin, Button, Select, Tooltip, Icon, Input } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import TableC from '../../basicElement/TableC';
import DateRange from '../../common/DateRange.new.js';
import SideNav from '../SideNav';
import moment from 'moment';
import ExportUtil from '../../../common/ExportUtil.js';

const monthFormat = 'YYYY-MM';
const { Option } = Select;
const constants = {
    siteFilter: {
        params: {
            statisticalType: 'Type_Filter',
        },
        typeName: '筛选',
    },
    siteInformed: {
        params: {
            statisticalType: 'Type_Informed',
        },
        typeName: '知情',
    },
    siteRandom: {
        params: {
            statisticalType: 'Type_Random',
        },
        typeName: '随机(入组)',
    },
};

class SiteCondition extends Component {
    constructor(props) {
        super(props);
        const { settlementType } = props;
        this.state = {
            loading: false,
            tableData: [],
            sortParams: {},
            searchParams: {
                selectValue: '0',
                settlementType,
            },
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.name !== prevProps.match.params.name) {
            const { settlementType } = this.props;
            this.setState({
                sortParams: {},
                searchParams: {
                    selectValue: '0',
                    settlementType,
                },
                pagination: {
                    pageSize: 10,
                    current: 1,
                },
            }, () => {
                this.loadData();
            });
        }
        if (this.props.settlementType !== prevProps.settlementType) {
            const { searchParams } = this.state;
            searchParams.settlementType = this.props.settlementType;
            this.setState({ searchParams }, () => {
                this.loadData();
            });
        }
    }

    loadData = () => {
        const { pagination, sortParams, searchParams } = this.state;
        const { current, pageSize } = pagination;
        const { name } = this.props.match.params;
        const { params } = constants[name];
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.summary.site,
            data: {
                offset: current,
                limit: pageSize,
                ...params,
                ...sortParams,
                ...searchParams,
            },
            dateType: 'json',
            doneResult: res => {
                const { totalCount, datas } = res;
                pagination.total = totalCount;

                this.setState({
                    loading: false,
                    tableData: datas,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options)
    }

    search = () => {
        const { pagination } = this.state
        pagination.current = 1
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams } = this.state;
        const { name } = this.props.match.params;
        const { params } = constants[name];
        const url = name === 'siteRandom' ? API_URL.summary.exportSitesSummary : API_URL.summary.exportSitesSummaryByType;
        ExportUtil.export({ 
            ...params,
            ...sortParams,
            ...searchParams,
        }, null, url);
    }

    getColumns = () => {
        const { name } = this.props.match.params;
        const { typeName } = constants[name];
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            sorter: true,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            sorter: true,
        }, {
            title: `计划${typeName}数`,
            dataIndex: 'planAmount',
            key: 'planAmount',
            sorter: true,
            width: 450,
        }, {
            title: `实际${typeName}数`,
            dataIndex: 'amount',
            key: 'amount',
            sorter: true,
        }];
        return columns;
    }

    handleInputChange = (e, key) => {
        const { searchParams } = this.state;
        searchParams[key] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        if (key === 'selectValue') {
            if (value == 1) {
                searchParams.begin = moment().format(monthFormat);
                searchParams.end = undefined;
            } else {
                searchParams.begin = undefined;
                searchParams.end = undefined;
            }
        }
        this.setState({ searchParams }, () => {
            this.loadData();
        });
    }

    handleDateChange = (value) => {
        const { searchParams } = this.state;
        const [begin, end] = value;
        searchParams.begin = begin;
        searchParams.end = end;
        this.setState({ searchParams });
    }

    handleTableChange = (params) => {
        this.setState({ ...params }, () => {
            this.loadData();
        });
    }

    render() {
        const { loading, tableData, pagination, sortParams, searchParams } = this.state;
        const { begin, end, settlementType, selectValue, investigationSiteCode, investigationSiteName } = searchParams;
        const { name } = this.props.match.params;
        const { typeName } = constants[name];
        const tipInfo = (
            <span>
                1、自然月，表示每月统计的数据范围，<br />
                为本月1号~月底产生的数据。<br />
                2、工时结算月，表示每月统计的数据<br />
                范围，为上月26号~本月25号产生的数据。
            </span>
        );
        return (
            <div className="content">
                <SideNav />
                <div className="main">
                    <Spin spinning={loading}>
                        <div className="T-tit">
                            <div className="txt">
                                <h3 style={{ marginBottom: 10 }}>{`各中心${typeName}情况`} </h3>
                            </div>
                        </div>
                        <div style={{ marginBottom: 20 }}>
                            <Select
                                style={{ width: 100, marginRight: 4 }}
                                value={selectValue}
                                onChange={value => this.handleSelectChange(value, 'selectValue')}
                            >
                                <Option value='0'>总体情况</Option>
                                <Option value='1'>本月情况</Option>
                                <Option value='2'>自定义</Option>
                            </Select>
                            {
                                selectValue !== "0" &&
                                <div style={{display: 'inline-block'}}>
                                    <span className="ant-divider" style={{ marginRight: 8 }} />
                                    <span style={{ marginRight: 10 }}>统计维度:</span>
                                    <Select
                                        style={{ marginRight: 10, width: 110 }}
                                        value={settlementType}
                                        onChange={value => this.handleSelectChange(value, 'settlementType')}
                                    >
                                        <Option value='BILLING_MONTH'>按工时结算月</Option>
                                        <Option value='NATURAL_MONTH'>按自然月</Option>
                                    </Select>
                                    <Tooltip placement="top" title={tipInfo}>
                                        <a><Icon style={{ marginRight: 10, fontSize: '14px', color: '#5750c9' }} type="info-circle" /></a>
                                    </Tooltip>
                                    {
                                        selectValue === "2" &&
                                        <DateRange
                                            allowClear={false}
                                            value={[begin, end]}
                                            style={{ width: 100 }}
                                            disabledDate={[11, 'M']}
                                            onChange={this.handleDateChange}
                                        />
                                    }
                                </div>
                            }
                            <div style={ selectValue !== "2" ? { float: 'right' } : { marginTop: 10 }}>
                                <span style={{ marginLeft: 10, marginRight: 10 }}>中心编号</span>
                                <Input
                                    placeholder="请输入"
                                    style={{ marginRight: 10, width: 120 }}
                                    value={investigationSiteCode}
                                    onChange={e => this.handleInputChange(e, 'investigationSiteCode')}
                                />
                                <span style={{ marginRight: 10 }}>中心名称</span>
                                <Input
                                    placeholder="请输入"
                                    style={{ marginRight: 10, width: 120 }}
                                    value={investigationSiteName}
                                    onChange={e => this.handleInputChange(e, 'investigationSiteName')}
                                />
                                <Button type="primary" style={{ marginRight: 10 }} onClick={this.search}>搜索</Button>
                                <Button type="primary" onClick={this.export}>导出</Button>
                            </div>
                        </div>
                        <TableC
                            className="siteCondition"
                            data={tableData}
                            sortParams={sortParams}
                            pagination={pagination}
                            columns={this.getColumns()}
                            onChange={this.handleTableChange}
                        />
                    </Spin>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { inProjectState: { settlementType } } = state;
    return {
        settlementType,
    };
};

export default connect(mapStateToProps, null)(SiteCondition);


// WEBPACK FOOTER //
// ./src/components/summary/siteCondition/index.js